import api from "../../services/api";
import { storageService } from "../../services/storageService";

/* eslint-disable no-use-before-define */
let globalTime: ReturnType<typeof setTimeout> | undefined;

let isConfigLoadedSuccessfully = false;

function inactivityTime() {
  let sessionTimeoutMs = 15 * 60 * 1000; 
  let lastReset = Date.now();
  let lastEventName = "initial_load";
  
  const syncTimer = (e: StorageEvent) => {
      if (e.key?.includes("lastActivity")) {
        resetTimer(false); 
      }
    };

  async function logout(isDowntimeLogout = false) {
    const currentClient = storageService.getClient(); 
    const ticketId = currentClient?.client?.ticket?.id || null;
    const lastGlobalActivity = storageService.getLastActivity();
    const now = Date.now();

    if (isDowntimeLogout && (now - lastGlobalActivity < sessionTimeoutMs)) {
      resetTimer(false); 
      return;
    }

    try {
      const actualInactivityMs = now - lastReset;
      
      const payload = {
        is_downtime_logout: isDowntimeLogout,
        reason: isDowntimeLogout ? `Inatividade após ${lastEventName}` : "Logout manual solicitado",
        threshold_minutes: sessionTimeoutMs / 60 / 1000,
        actual_inactivity_seconds: Math.floor(actualInactivityMs / 1000),
        hasTicket: ticketId ?? false,
        last_event_type: lastEventName,
        client_timestamp: new Date().toISOString()
      };

      await api.post("logout_by_inactivity", payload);
    } catch (err) {
      console.error("Erro no logout por inatividade:", err);
    } finally {
      storageService.clearAll();
      await clearCacheData();
      window.location.href = `${window.location.origin  }/`;
    }
  }

  function resetTimer(propagate = true) {
    if (globalTime) clearTimeout(globalTime);

    if (propagate) {
      storageService.setLastActivity();
    }

    if (sessionTimeoutMs > 0) {
      globalTime = setTimeout(() => logout(true), sessionTimeoutMs);
    }
  }

  function throttledReset(event: Event) {
    const now = Date.now();
    if (now - lastReset < 2000) return;
    
    lastReset = now;
    lastEventName = event.type;
    resetTimer(true);
  }

  const events = ["mousedown", "mousemove", "keypress", "scroll", "touchstart"];

  const setupEventListeners = () => {
    events.forEach((event) => {
      window.addEventListener(event, throttledReset, { passive: true });
    });

    window.addEventListener("storage", syncTimer);
  };

  async function loadSessionConfig() {
    if (isConfigLoadedSuccessfully) return;

    try {
      const response = await api.get("get_session_time");
      const downtime = response?.session_downtime || response?.data?.session_downtime;
      if (downtime) {
        sessionTimeoutMs = downtime * 60 * 1000;
        isConfigLoadedSuccessfully = true;
      } else {
        sessionTimeoutMs = 15 * 60 * 1000;
      }
     } catch (error) {
         sessionTimeoutMs = 15 * 60 * 1000;
       }

    resetTimer();
  }

  async function clearCacheData() {
    try {
      if ("caches" in window) {
        const names = await caches.keys();
        await Promise.all(names.map((name) => caches.delete(name)));
      }
    } catch (err) {
      console.error("Erro ao limpar cache:", err);
    }
  }

  function clearLocalStorage() {
    try {
      localStorage.clear();
    } catch (err) {
      console.error("Erro ao limpar localStorage:", err);
    }
  }

  setupEventListeners();
  loadSessionConfig();

  return () => {
    if (globalTime) clearTimeout(globalTime);
    events.forEach((event) => {
      window.removeEventListener(event, throttledReset);
    });
    window.removeEventListener("storage", syncTimer);
  };
}

export default inactivityTime;